import { JsonSchemaValidator } from "@common/json-schema-validator";
import { iamAccountRawPassword } from "../schema";
import { IAMAccountRawPassword } from "../interface";

export class IAMAccountPasswordUpdateCmd {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountPasswordUpdateCmd.validationSchema()
  );

  constructor(readonly value: IAMAccountPasswordUpdateCmdRaw) {
    JsonSchemaValidator.assert(IAMAccountPasswordUpdateCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["currentPassword", "newPassword"],
      properties: {
        currentPassword: iamAccountRawPassword,
        newPassword: iamAccountRawPassword
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountPasswordUpdateCmdRaw {
  currentPassword: IAMAccountRawPassword;
  newPassword: IAMAccountRawPassword;
}
